
import { CharacterFeatureSource } from "@dndModels/character_feature_source/CharacterFeatureSource";
import { SpecialFeature } from "@dndModels";
import { 
  CharacterFeatureBase,
} from "@dndModels";
import { DataType } from "@dndModels/Types";

export class CharacterSpecialFeature extends CharacterFeatureSource {
  source_source_id = "";
  source: SpecialFeature | null = null;

  get data_type(): DataType {
    return "special_feature";
  }
  
  constructor(obj?: any) {
    super(obj);
    // console.log(obj);
    if (obj) {
      if (obj.special_feature_id) {
        this.source_id = obj.special_feature_id;
        this.source_source_id = obj.source_id;
      } else if (obj.source_source_id) {
        this.source_source_id = obj.source_source_id;
      }
      if (this.char_feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        obj.features.forEach((o: any) => {
          const fb = new CharacterFeatureBase(o);
          fb.source_id = this.source_id;
          fb.source_name = this.name;
          fb.source_type = "SpecialFeature";
          // fb.root_id = this.source_source_id;
          // fb.root_name = this.source_name;
          // fb.root_type = this.source_type;
          fb.ancestries = [...this.ancestries.map(o => { return {...o}; })];
          this.char_feature_bases.push(fb);
        });
      }
    }
  }

  get repeatable(): boolean {
    return this.source?.repeatable??false;
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      source_source_id: this.source_source_id
    };
  }

  clone(drop_ids = false): CharacterSpecialFeature {
    const clone = new CharacterSpecialFeature();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterSpecialFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.source_source_id = copyMe.source_source_id;
    this.source = copyMe.source?.clone()??null;
  }
}